// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "bootstrap"
import "bootstrap-select"
import 'select2/dist/css/select2.min.css';
import "select2"
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

require("metisMenu/jquery.metisMenu")
require("slimscroll/jquery.slimscroll.min")
require("packs/inspinia")
require("dataTables/datatables.min")
require("dataTables/dataTables.bootstrap4.min")
require("packs/h-smart-thumbnail")
require("packs/jquery.raty")
require("packs/ratyrate")
require("packs/imagesloaded.min")
require("packs/custom")
require("packs/rails_sortable")
global.toastr = require("toastr")

Rails.start()
Turbolinks.start()
ActiveStorage.start()

console.log("Hello from application.js");

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("controllers", true, /.js$/)
application.load(definitionsFromContext(context))

var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
